import React from 'react';
import { Provider } from 'react-redux';
import { getStore } from './store';

const StoreProvider = ({ children }) => {
  const store = getStore();
  return <Provider store={store}>{children}</Provider>;
};

export default StoreProvider;
